import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { TextField, Grid, FormControlLabel, Switch, Button, Typography, } from '@material-ui/core';
import InputMask from 'react-input-mask';

import { addEndereco, getEndereco, buscarEnderecoCEP } from '../../store/actions/endereco';
import TituloPagina from '../../components/layout/TituloPagina';
import If from '../../components/condicional/if';
import { getNumbers } from '../../assets/js/formatNumber';

const EnderecoCadastro = props => {
    const { addEndereco, getEndereco, endereco } = props;
    const { origem, idOrigem, idEndereco } = useParams();
    const [disableFields, setDisableFields] = useState(false);

    useEffect(() => {
        if (idEndereco && idEndereco > 0) {
            getEndereco(idEndereco);
        }
    }, [idEndereco]);

    const validationSchema = yup.object().shape({
        cep: yup.string().required('Informe o CEP do seu endereço'),
        apelidoIdentificacao: yup.string().required('Dê um apelido para identificar o endereço'),
        logradouro: yup.string().required('Informe o logradouro'),
        bairro: yup.string().required('Informe o bairro'),
        cidade: yup.string().required('Informe a cidade'),
        estado: yup.string().required('Informe o estado'),
        numero: yup.string().required('Informe o número'),
    })

    const formik = useFormik({
        initialValues: {
            id: endereco?.id ?? '',
            apelidoIdentificacao: endereco?.apelidoIdentificacao ?? '',
            cep: endereco?.cep ?? '',
            logradouro: endereco?.logradouro ?? '',
            numero: endereco?.numero ?? '',
            complemento: endereco?.complemento ?? '',
            bairro: endereco?.bairro ?? '',
            cidade: endereco?.cidade ?? '',
            estado: endereco?.estado ?? '',
            ativo: endereco?.ativo ?? false,
            principal: endereco?.principal ?? false
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {

            let idNegocio, idUsuario;

            if (origem === 'negocios') idNegocio = idOrigem 
            else idUsuario = idOrigem;
            
            const data = { ...values, idNegocio, idUsuario };
            addEndereco(data);
            setDisableFields(true);
        },
        enableReinitialize: true,
    });

    async function handleCep(e) {
        let cep = String(getNumbers(e.target.value));
        if (cep.length === 8) {
            const { logradouro, bairro, localidade, uf } = await buscarEnderecoCEP(cep);
            formik.setFieldValue('logradouro', logradouro);
            formik.setFieldValue('bairro', bairro);
            formik.setFieldValue('cidade', localidade);
            formik.setFieldValue('estado', uf);
        }
    }

    return (
        <>
            <TituloPagina titulo='Cadastro de Endereço' subtitulo={new Date().toLocaleString('pt-BR')} />
            <Grid container item xs={12} style={{ paddingTop: '15px' }}>
                <Grid container>
                    <Typography variant='body1' component='p'>
                        Informe abaixo os dados do endereço. Alguns campos são preenchidos automaticamente assim que você informar o CEP.
                    </Typography>
                </Grid>
                <form onSubmit={formik.handleSubmit} noValidate autoComplete='off'>
                    <div style={{ flexGrow: 1, paddingTop: '15px' }}>
                        <Grid container spacing={2}>
                            <Grid item xs={6} sm={3}>
                                <InputMask
                                    mask='99.999-999'
                                    maskChar=' '
                                    disabled={disableFields}
                                    value={formik.values.cep}
                                    onChange={(value) => {
                                        formik.handleChange(value);
                                        handleCep(value);
                                    }}>
                                    {() => <TextField
                                        fullWidth
                                        id='cep'
                                        name='cep'
                                        label='CEP'
                                        variant='filled'
                                        error={formik.touched.cep && Boolean(formik.errors.cep)}
                                        helperText={formik.touched.cep && formik.errors.cep}
                                    />}
                                </InputMask>
                            </Grid>
                            <Grid item xs={6} sm={9}>
                                <TextField
                                    fullWidth
                                    id='apelidoIdentificacao'
                                    name='apelidoIdentificacao'
                                    label='Nome de Identificação do Endereço'
                                    variant='filled'
                                    disabled={disableFields}
                                    value={formik.values.apelidoIdentificacao}
                                    onChange={formik.handleChange}
                                    error={formik.touched.apelidoIdentificacao && Boolean(formik.errors.apelidoIdentificacao)}
                                    helperText={formik.touched.apelidoIdentificacao && formik.errors.apelidoIdentificacao}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    id='logradouro'
                                    name='logradouro'
                                    label='Logradouro'
                                    variant='filled'
                                    disabled={true}
                                    value={formik.values.logradouro}
                                    onChange={formik.handleChange}
                                    error={formik.touched.logradouro && Boolean(formik.errors.logradouro)}
                                    helperText={formik.touched.logradouro && formik.errors.logradouro}
                                />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <TextField
                                    fullWidth
                                    id='numero'
                                    name='numero'
                                    label='Número'
                                    variant='filled'
                                    disabled={disableFields}
                                    value={formik.values.numero}
                                    onChange={formik.handleChange}
                                    error={formik.touched.numero && Boolean(formik.errors.numero)}
                                    helperText={formik.touched.numero && formik.errors.numero}
                                />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <TextField
                                    fullWidth
                                    id='complemento'
                                    name='complemento'
                                    label='Complemento'
                                    variant='filled'
                                    disabled={disableFields}
                                    value={formik.values.complemento}
                                    onChange={formik.handleChange}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    id='bairro'
                                    name='bairro'
                                    label='Bairro'
                                    variant='filled'
                                    disabled={true}
                                    value={formik.values.bairro}
                                    onChange={formik.handleChange}
                                    error={formik.touched.bairro && Boolean(formik.errors.bairro)}
                                    helperText={formik.touched.bairro && formik.errors.bairro}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    id='cidade'
                                    name='cidade'
                                    label='Cidade'
                                    variant='filled'
                                    disabled={true}
                                    value={formik.values.cidade}
                                    onChange={formik.handleChange}
                                    error={formik.touched.cidade && Boolean(formik.errors.cidade)}
                                    helperText={formik.touched.cidade && formik.errors.cidade}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    id='estado'
                                    name='estado'
                                    label='Estado'
                                    variant='filled'
                                    disabled={true}
                                    value={formik.values.estado}
                                    onChange={formik.handleChange}
                                    error={formik.touched.estado && Boolean(formik.errors.estado)}
                                    helperText={formik.touched.estado && formik.errors.estado}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <FormControlLabel
                                    control={<Switch
                                        checked={formik.values.ativo}
                                        onChange={formik.handleChange}
                                        name="ativo"
                                        disabled={disableFields} />}
                                    label="Endereço Ativo"
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <FormControlLabel
                                    control={<Switch
                                        checked={formik.values.principal}
                                        onChange={formik.handleChange}
                                        name="principal"
                                        disabled={disableFields} />}
                                    label="Endereço Principal"
                                />
                            </Grid>

                        </Grid>
                        <Grid container pt={4} style={{ paddingTop: '25px', paddingBottom: '25px' }}>
                            <If test={!disableFields}>
                                <Grid item style={{ paddingRight: '15px' }}>
                                    <Button type='submit' color='secondary' variant='contained'>Salvar</Button>
                                </Grid>
                                <Grid item style={{ paddingRight: '15px' }}>
                                    <Button variant='contained' href={`/enderecos/${origem}/${idOrigem}`}>Cancelar</Button>
                                </Grid>
                            </If>
                            <If test={disableFields}>
                                <Grid item style={{ paddingRight: '15px' }}>
                                    <Button color='secondary' variant='contained' href={`/enderecos/${origem}/${idOrigem}`}>Voltar</Button>
                                </Grid>
                            </If>
                        </Grid>
                    </div>
                </form>
            </Grid>
        </>
    )
}

const mapStateToProps = state => ({
    endereco: state.endereco.endereco
})

const mapDispatchToProps = dispatch => bindActionCreators({
    addEndereco,
    getEndereco
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(EnderecoCadastro)